<template>
  <v-chip label x-small :color="color" text-color="white" class="font-weight-bold px-2">
    {{ label }}
  </v-chip>
</template>
<script>
export default {
  computed: {
    label() {
      const labels = {
        pending: "Pending",
        processing: "Processing",
        completed: "Completed",
        failed: "Failed",
      };
      return labels[this.params.value] || this.params.value;
    },
    color() {
      const colors = {
        pending: "grey darken-1",
        processing: "amber darken-2",
        completed: "green darken-1",
        failed: "red darken-1",
      };
      return colors[this.params.value] || "grey";
    },
  },
};
</script>
